export function transformToBackend(data: any) { // eslint-disable-line
  return {
    data: data.rowData,
  };
}

export function transformFromBackend(backendType: any) { // eslint-disable-line
  return backendType;
}
